import { Id } from "./id";

type ConfigurationProfile = {
  name: string;
  roles: Id[];
  columns: { key: string }[];
};

type ResourceDetailsConfiguration = ConfigurationProfile[];

const resourceDetailsConfiguration: ResourceDetailsConfiguration = [];

export type { ResourceDetailsConfiguration };

export { resourceDetailsConfiguration };
